import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/scaling-pharmacovigilance-in-europe-a-practical-guide-for-pharma-smes-and-biotechs")({
  head: () => buildRouteHead("/scaling-pharmacovigilance-in-europe-a-practical-guide-for-pharma-smes-and-biotechs", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/services/pharmacovigilance", replace: true });
  },
});
